import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import config from "../config/config";

const AddCustomerDialog = ({ open, onClose, onCustomerAdded }) => {
  const { token } = useAuth();
  const { showToast } = useToast();
  const [form, setForm] = useState({
    name: "",
    phone: "",
  });
  const [validationErrors, setValidationErrors] = useState({});

  const handleClose = () => {
    onClose();
    setForm({ name: "", phone: "" });
    setValidationErrors({});
  };

  const handleSubmit = async () => {
    const errors = {};
    if (!form.name) {
      errors.name = "Tên khách hàng là bắt buộc.";
    }
    // if (!form.phone) {
    //   errors.phone = "Số điện thoại là bắt buộc.";
    // }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    try {
      const res = await axios.post(
        `${config.backendUrl}/api/customers`,
        form,
        {
          headers: { "x-auth-token": token },
        }
      );
      showToast("Khách hàng đã được thêm thành công!", "success");
      if (onCustomerAdded) {
        onCustomerAdded(res.data);
      }
      handleClose();
    } catch (err) {
      console.error(err);
      const errorMessage =
        err.response?.data?.message || "Đã xảy ra lỗi khi thêm khách hàng.";
      showToast(errorMessage, "error");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Thêm khách hàng mới</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Tên khách hàng"
          type="text"
          fullWidth
          variant="outlined"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          error={!!validationErrors.name}
          helperText={validationErrors.name}
        />
        <TextField
          margin="dense"
          label="Số điện thoại"
          type="text"
          fullWidth
          variant="outlined"
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
          error={!!validationErrors.phone}
          helperText={validationErrors.phone}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Hủy</Button>
        <Button onClick={handleSubmit} variant="contained">
          Thêm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCustomerDialog;
